import { Button } from '@patternfly/react-core';
import useMobxStores from 'hooks/useMobxStores';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import { observer } from 'mobx-react';

const VideoTourDisplay = () => {
  const { uiStore } = useMobxStores();
  const { t } = useTranslation();

  return (
    uiStore.isTourDisplayed && (
      <div className="tour-wrapper">
        <div className="overlay">
          <div className="overlay-content">
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                paddingBottom: '56.25%',
              }}
            >
              <iframe
                src={uiStore.videoToPlay}
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="auto"
                style={{ position: 'absolute', height: '100%' }}
                allowFullScreen
                title={t('Welcome to the Red Hat Learning Subscription')}
              />
            </div>
            <div className="text-center">
              <Button
                type="button"
                variant="danger"
                onClick={() => {
                  uiStore.toggleTour();
                }}
              >
                {t('Close video')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default observer(VideoTourDisplay);
